import StoreSimpleView from './StoreSimpleView'

export default StoreSimpleView
